var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactEnvelop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M313 4343 c-29 -9 -53 -20 -53 -25 0 -6 498 -509 1108 -1119 l1107 -1108 48 -7 c111 -15 25 -92 1236 1121 606 607 1101 1108 1101 1113 0 5 -26 17 -58 26 -53 15 -252 16 -2248 15 -1945 -1 -2195 -2 -2241 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 4068 c-18 -41 -19 -105 -22 -1487 -2 -1262 0 -1451 13 -1495 8 -28 19 -58 25 -66 8 -12 166 141 787 762 l778 778 -775 775 c-426 426 -778 775 -781 775 -4 0 -15 -19 -25 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4290 3335 l-775 -775 778 -778 c621 -621 779 -774 787 -762 6 8 17 38 25 66 13 44 15 233 13 1495 -3 1382 -4 1446 -22 1487 -10 23 -21 42 -25 42 -3 0 -355 -349 -781 -775z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1027 1580 c-422 -423 -767 -773 -767 -778 0 -5 26 -17 58 -26 53 -15 253 -16 2242 -16 1989 0 2189 1 2242 16 32 9 58 21 58 26 0 5 -346 356 -769 781 l-769 772 -244 -241 c-206 -205 -253 -246 -308 -272 -135 -66 -286 -66 -419 -1 -56 27 -102 67 -307 271 -132 131 -243 238 -246 238 -2 0 -350 -346 -771 -770z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEnvelop);
export default __webpack_public_path__ + "static/media/contact-envelop.4cb3ac682d5b64bed6c16a09f3d28770.svg";
export { ForwardRef as ReactComponent };